import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/lib/data';
import { DEFAULT_SERVICES } from '@/lib/defaults';
import { Reveal, HoverCard } from '@/components/Reveal';
import { SEO, createBreadcrumbSchema } from '@/components/SEO';
import { Breadcrumb } from '@/components/Breadcrumb';
import { ServiceCard } from '@/components/ServiceCard';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export default function ServicesPage() {
  const [services, setServices] = useState(DEFAULT_SERVICES);

  useEffect(() => {
    axios.get(`${API}/services`).then(r => setServices(r.data)).catch(console.error);
  }, []);

  return (
    <div data-testid="services-list">
      <SEO title="Tedaviler" description="Prof. Dr. Nilüfer Yıldırım - Fonksiyonel Tıp, Hormonal Antiaging, Koruyucu Hekimlik ve Stres Yönetimi tedavilerimizi inceleyin. Ankara'da kişiye özel sağlık çözümleri." schema={createBreadcrumbSchema([{ name: 'Ana Sayfa', url: '/' }, { name: 'Tedaviler' }])} />
      {/* Header */}
      <section className="bg-[#F5F3EF] py-16 sm:py-20">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-10">
          <h1 className="font-heading text-[34px] sm:text-[34px] lg:text-[46px] font-semibold tracking-[-0.02em] mb-4">Tedavilerimiz</h1>
          <p className="text-[22px] text-[#5F6B76] max-w-xl">Sağlığınıza bütüncül bir yaklaşımla, kişiye özel programlar sunuyoruz.</p>
        </div>
      </section>

      <Breadcrumb items={[{ label: 'Tedaviler', href: '/hizmetler', current: true }]} />

      {/* Service Cards */}
      <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-10 py-16">
        <div className="space-y-6 max-w-5xl mx-auto">
          {services.map((s, i) => (
            <Reveal key={s.id} variant="fadeUp" delay={i * 100}>
              <ServiceCard service={s} index={i} />
            </Reveal>
          ))}
        </div>
      </section>

      {/* CTAs */}
      <Reveal>
        <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-10 py-16 text-center">
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/surec"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#F5F3EF] border border-[#E7E5E4] text-[#1F2937] text-sm font-semibold hover:-translate-y-0.5 transition-all"
            >
              Tedavi Süreci Nasıl İşliyor? <ArrowRight size={16} />
            </Link>
            <Link
              to="/iletisim"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#1F6E7A] text-white text-sm font-semibold shadow-[0_8px_24px_-12px_rgba(31,110,122,0.4)] hover:bg-[#185960] hover:-translate-y-0.5 transition-all"
            >
              Randevu Al
            </Link>
          </div>
        </section>
      </Reveal>
    </div>
  );
}
